<div class="app">
    <fgai-menu role="banner" /><fgai-toast-container aria-live="polite" aria-atomic="true" />
    
    <main class="main-content mt-5 mb-5">
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    </main>
    <fgai-footer role="contentinfo" />
</div>
